import React from "react";
import { isEmpty } from "lodash";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Error as ErrorIcon } from "@material-ui/icons";

import useInvoicePayments from "../../../hooks/useInvoicePayments";
import { InvoicePayments } from "./InvoicePayments";
import { CancelCOIssueSummary, Title } from "./CancelCOIssueSummary";
import Loader from "../../../ui/Loader";
import { ActionButtons } from "../../../forms";

const MessageContainer = styled.div`
  display: flex;
  column-gap: 8px;
`;

const CancelIssuedOrderDescription = ({ hasRevisions }) => {
  if (hasRevisions) {
    return (
      <MessageContainer>
        <StyledErrorIcon fontSize="small" />
        <Title>
          Are you sure you want to Cancel Purchase Order Issue? Cancelling
          Purchase Order Issue will update the <b>PO Status</b> to{" "}
          <b>Pending Approval, reverting ALL</b> changes done through Change
          Order(s).
        </Title>
      </MessageContainer>
    );
  }

  return <Title>Are you sure you want to Cancel Purchase Order Issue?</Title>;
};
CancelIssuedOrderDescription.propTypes = {
  hasRevisions: PropTypes.bool,
};

const Wrapper = styled.div`
  padding: 24px;
`;

const StyledErrorIcon = styled(ErrorIcon)`
  color: #ff1744;
`;

const getCancelIssueError = (changeOrder, invoicePayments) =>
  isEmpty(invoicePayments) ||
  (changeOrder
    ? !isEmpty(invoicePayments.specPaymentsInChangeOrder) ||
      !isEmpty(invoicePayments.specPriceChangesInChangeOrder)
    : !isEmpty(invoicePayments.specPayments));

const Dialog = ({
  invoicePayments,
  changeOrder,
  hasRevisions,
  cancelIssueError,
}) => {
  if (cancelIssueError) {
    return (
      <InvoicePayments
        invoicePayments={invoicePayments}
        changeOrder={changeOrder}
      />
    );
  }

  return changeOrder ? (
    <CancelCOIssueSummary invoicePayments={invoicePayments} />
  ) : (
    <CancelIssuedOrderDescription hasRevisions={hasRevisions} />
  );
};
Dialog.propTypes = {
  invoicePayments: PropTypes.shape({}),
  changeOrder: PropTypes.bool,
  hasRevisions: PropTypes.bool,
  cancelIssueError: PropTypes.bool,
};

const CancelIssueDialog = ({
  purchaseOrderId,
  changeOrder,
  hasRevisions,
  onSubmit,
}) => {
  const { invoicePayments, loading } = useInvoicePayments(purchaseOrderId);
  const cancelIssueError = getCancelIssueError(changeOrder, invoicePayments);

  return (
    <React.Fragment>
      <Wrapper>
        <Loader loading={loading} count={10}>
          <Dialog
            cancelIssueError={cancelIssueError}
            invoicePayments={invoicePayments}
            changeOrder={changeOrder}
            hasRevisions={hasRevisions}
          />
        </Loader>
      </Wrapper>
      <ActionButtons
        onSend={onSubmit}
        isModal={true}
        sendButtonText="Confirm Cancellation"
        cancelButtonText="Back"
        additionalProps={{
          send: { isLoading: loading, disabled: cancelIssueError },
          cancel: { loading },
        }}
      />
    </React.Fragment>
  );
};
CancelIssueDialog.propTypes = {
  purchaseOrderId: PropTypes.string,
  changeOrder: PropTypes.bool,
  hasRevisions: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};
export default CancelIssueDialog;
